import { render, staticRenderFns } from "./campaignSummary.vue?vue&type=template&id=6d2ef792&"
import script from "./campaignSummary.vue?vue&type=script&lang=js&"
export * from "./campaignSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports